{
  "name": "hayagriva",
  "version": "0.0.07-BETA",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration development",
    "start:prod": "ng serve --configuration production",
    "start:test": "ng serve --configuration test",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "build:test": "ng build --configuration test",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch --code-coverage",
    "server": "./start-server.sh",
    "server:raw": "node server.js",
    "server:test": "PORT=3001 ./start-server.sh",
    "e2e:development": "ng e2e --configuration development"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.7",
    "@angular/cdk": "^20.2.10",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@coreui/angular": "^5.5.17",
    "@coreui/angular-chartjs": "^5.5.17",
    "@coreui/chartjs": "^4.0.0",
    "@coreui/coreui": "^5.4.3",
    "@coreui/icons": "^3.0.1",
    "@coreui/icons-angular": "^5.5.17",
    "@faker-js/faker": "^10.1.0",
    "@katoid/angular-grid-layout": "^3.1.0",
    "@optima-stride-ai/core": "^0.0.70",
    "@optima-stride-ai/optima-app-framework": "^0.0.149",
    "@optima-stride-ai/optima-components": "^0.61.3-alpha.0",
    "@optima-stride-ai/optima-platform": "^0.0.48",
    "@primeuix/themes": "^1.2.5",
    "angular-split": "^20.0.0",
    "axios": "^1.13.2",
    "browser-image-compression": "^2.0.2",
    "chart.js": "^4.5.1",
    "cors": "^2.8.5",
    "d3": "^7.9.0",
    "d3-org-chart": "^3.1.1",
    "dom-to-image": "^2.6.0",
    "easymde": "^2.20.0",
    "express": "^4.19.2",
    "fabric": "^7.4.0",
    "file-saver": "^2.0.5",
    "file-type": "^21.1.1",
    "html-to-image": "^1.11.13",
    "jsonwebtoken": "^9.0.2",
    "jszip": "^3.10.1",
    "marked": "^16.4.1",
    "mathjs": "^14.9.1",
    "multer": "^2.0.2",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-editor": "^19.0.0-beta.1",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^5.4.449",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "read-excel-file": "^6.0.1",
    "rxjs": "~7.8.0",
    "sharp": "^0.34.5",
    "sheetjs-style": "^0.15.8",
    "socket.io-client": "^4.8.3",
    "tslib": "^2.3.0",
    "turndown": "^7.2.2",
    "turndown-plugin-gfm": "^1.0.2",
    "y-websocket": "^3.0.0",
    "yjs": "^13.6.28",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "^21.1.3",
    "@angular/compiler-cli": "^20.3.0",
    "@types/dom-to-image": "^2.6.7",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/pdfjs-dist": "^2.10.377",
    "@types/turndown": "^5.0.6",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}
